<template>
  <div class="Summary">
    <div class="checkout--page__cart" v-if="!cart.length">
      <p>{{ $t('cart.title_noproductsincart') }}</p>
      <br/>
      <a :href="'#/list/' + module_id">{{ $t('cart.cta_goback') }}</a>
    </div>

    <div class="cart" v-if="cart.length > 0">
      <div class="cart-wrapper">
        <h3 class="text-center">{{ $t('summary.title') }}</h3><br>

        <div class="cart-items-list">
          <template v-for="cart_item in cart">
            <cart-row :cart_item="cart_item" :can_remove="true" :currency="currency"></cart-row>
          </template>
        </div>


        <div class="coupon-code" v-show="display_coupon">
          <div class="coupon-input">
            <div class="apply-coupon">
              <input type="text" :placeholder="$t('summary.coupon_placeholder')" v-model="code">
              <button type="button" @click="confirm_coupon(code)">{{ $t('summary.coupon_cta_apply') }}</button>
            </div>
            <div v-show="visitor_modifiers && visitor_modifiers.length > 0">
              <div v-for="modifier in visitor_modifiers" class="active__coupon">
                <p><strong>{{ modifier.code }}</strong></p>
                <button class="btn btn-default coupon--remove" @click="remove_coupon({ code: modifier.code })">{{ $t('summary.coupon_cta_remove') }}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="cart-calculation">
          <ul class="list-unstyled">
            <li v-show="discounted == total">
                <h5>{{ $t('cart.title_totalamount') }}</h5>
                <p>{{ total | formatCurrency(currency) }}</p>
            </li>

            <li v-show="display_coupon && visitor_modifiers && visitor_modifiers.length > 0">
                <p>{{ $t('cart.title_totalamount') }}</p>
                <p style="text-decoration: line-through;">{{ total | formatCurrency(currency) }}</p>
            </li>

            <li v-show="display_coupon && visitor_modifiers && visitor_modifiers.length > 0">
                <p>{{ $t('cart.title_discountedamount') }}</p>
                <p>{{ discounted | formatCurrency(currency) }}</p>
            </li>
          </ul>
        </div>

      </div>

      <div class="cart-total" v-if="!showShipping">
        <ul class="list-unstyled">
          <li>
            <h4>{{ $t('summary.title_total') }}</h4>
            <p class="total-price">{{ discounted | formatCurrency(currency) }}</p>
          </li>
        </ul>
      </div>

      <shipping :total="discounted"></shipping>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import SummaryItem from './_partials/summary-item.vue';
  import Shipping from './Shipping.vue';
  import CartRow from '../cart/_partials/items-row.vue';

  export default {
    data () {
      return {
        code: '',
      };
    },

    components: {
      SummaryItem,
      Shipping,
      CartRow
    },

    computed: {
      ...mapGetters([
        'active_module',
        'active_gateway',
        'cart',
        'amount_with_modifiers_normal',
        'amount_with_modifiers_normal_after_coupon',
        'amount_with_modifiers_partial',
        'amount_with_modifiers_partial_after_coupon',
        'visitor_modifiers',
        'selected_partial',
      ]),

      ...mapState({
        shipping_list: state => state.Cart.shipping_list
      }),

      currency () {
        return this.active_module.currency;
      },

      module_id () {
        return this.active_module.module_id;
      },

      discounted () {
        return this.amount_with_modifiers_normal_after_coupon;
      },

      total () {
        return this.amount_with_modifiers_normal;
      },

      showShipping () {
        return !!this.shipping_list.length;
      },

      display_coupon: function () {
        if (this.active_module == null || this.active_module.settings.payment == null || this.active_module.settings.payment.coupon === '') {
          return false;
        } else {
          return true;
        }
      }
    },

    methods: {
      ...mapActions([
        'delete_item',
        'update_quantity',
        'apply_coupon',
        'remove_coupon',
      ]),

      confirm_delete (product_id) {
        this.delete_item(product_id);
      },

      confirm_coupon (code) {
        if (code !== '') {
          this.apply_coupon({code: code});
          this.code = '';
        }
      }
    }
  };
</script>

<style scoped>

  .Summary {
    font-family: 'Roboto';
    font-weight: 300;
  }
    .cart {
        background-color: #FAFAFA;
        /*margin-top: 20px;*/
        border: 1px solid #ddd;
        padding: 5%;
    }

    .cart p, h5, h4, h3, h2 {
        margin: 0;
    }

    ul {
        margin-bottom: 0;
    }

    .modifiers-list {
        margin-left: 10px;
    }

    .cart-product {
        border-top: 1px solid #ddd;
        padding: 10px 0 5px 0;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .product-price {
        font-weight: 600;
        background-color: #7f8c8d;
        padding: 4px 10px;
        color: #fff;
        /*margin: 0;*/
        margin-left: 20px !important;
    }

    .product-quantity {
        display: flex;
        align-items: center;
        margin-left: 10px;
    }

    .cart-calculation {
        /*margin-top: 10px;*/
        border-top: 1px solid #ddd;
        padding-top: 10px;
    }

    .cart-calculation li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .cart-calculation li p {
        font-weight: 600;
    }

    .cart-total {
        padding-top: 10px;
        border-top: 1px solid #ddd;
    }

    .cart-total ul li {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .no-discount-price {
        font-size: 18px;
    }

    .total-price {
        font-size: 30px;
        font-weight: 400;
        color: #B6CD77;
    }

    .product-name {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;

    }

    .product-name span {
        font-size: 14px;
        font-weight: 400;
    }

    .cart-total h4 {
        font-size: 20px;
        font-weight: 600;
    }

    .coupon-code {
        width: 100%;
        padding: 10px 0;
        border-top: 1px solid #ddd;
        /*display: flex;
        align-items: center;*/
    }

    .apply-coupon {
        display: flex;
    }

    .active__coupon .coupon--remove {
        margin: 0;
        margin-left: 10px;
    }

    .active__coupon {
        display: flex;
        align-items: center;
        margin-top: 10px;
    }

    .coupon-code input {
        padding: 5px;
    }

    .coupon-input {
        /*display: flex;
        justify-content: space-between;*/
        margin-top: 5px;
    }

    .coupon-code button {
        margin-left: 10px;
    }

    .form-control {
        box-shadow: none;
        height: auto;
    }

    .form-group {
        margin-bottom: 0;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .checkout--page__cart {
        border: 1px solid #ddd;
        padding: 5%;
    }

    .checkout--page__cart p {
        margin: 0;
    }

    .coupon {
        width: 50%;

    }

    .coupon__field {
        width: 95%;
        border-radius: 0px;
        border: 1px solid #ddd;
        padding: 1%;
    }

    .cart-inner__items--price {
        margin-right: 13px !important;
        color: #4B77BE;
        font-size: 17px;
        font-weight: 400;
    }

    .cart-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-footer .coupon--add, .coupon--remove {
        background: linear-gradient(to bottom, #f7f8fa, #e7e9ec);
        color: #111;
        border: 0;
        border-radius: 0;
        margin-top: 10px;
        padding: 3px 12px;

    }

    .cart-footer .coupon__code {
        /*margin-top: 20px;*/
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .cart-footer .coupon--remove {
        top: 40px;
        padding: 4px 12px;
    }

    .checkout--page__cart .checkout--page__cart__inner {
        /*border-bottom: 1px solid #ddd;*/
        padding-bottom: 4%;
    }

    .cart-item__name {
        color: #111;
        font-weight: 700;
    }

    .cart-total {
        color: #111;
    }

    .checkout--page__cart .cart--inner__items {
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #ddd;
        /*-ms-flex-pack: justify;
            justify-content: space-between;
        -ms-flex-align: baseline;
            align-items: baseline;*/
    }

    /*.checkout--page__cart .cart--inner__items select {
      width: 8%; }*/
    .checkout--page__cart .cart--inner__items .cart--inner__items--price {
        /*font-size: 17px;*/
        color: #111;
        /*font-weight: 600;*/
    }

    .checkout--page__cart .cart--inner__items .cart--inner__item {
        display: -ms-flexbox;
        display: flex;
    }

    .cart-item--inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        min-height: 62px;
    }

    .cart-product__name {
        width: 70%;
    }

    .cart-price {
        width: 30%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .sub-product__name {
        display: flex;
        flex-direction: column;

    }

    .sub-product__item, .sub-product__price {
        position: absolute;
        bottom: 0px;
        margin-bottom: 0;
    }

    .sub-product__price {
        color: #111;
        margin-top: 8px;
    }

    .sub-product .sub-product__name {
        font-weight: 600;
        margin-right: 10px;
        color: #111;
    }

    .checkout--page__cart .checkout--page__discount {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: end;
        justify-content: flex-end;
        -ms-flex-align: center;
        align-items: center;
        margin: 3% 0% 3% 0%;
        padding: 0% 0% 4% 0%;
        border-bottom: 1px solid #ddd;
    }

    .checkout--page__cart .checkout--page__discount .checkout--page__coupon__code {
        padding: 1%;
    }

    .checkout--page__cart .checkout--page__discount .btn {
        color: #ffffff;
        background: linear-gradient(to bottom, #1F3A93, #3A539B);
        margin-left: 2%;
    }

    .checkout--page__cart .checkout--page__discount__value {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: end;
        justify-content: flex-end;
        font-size: 16px;
    }

    .checkout--page__cart .checkout--page__discount__value p:last-child {
        margin-left: 2%;
    }

    .checkout--page__cart .checkout--page__cart__total {
        /*display: -ms-flexbox;*/
        display: flex;
        flex-direction: column;

        /*-ms-flex-pack: end;
            justify-content: flex-end;*/
        padding-top: 5px;
        font-size: 18px;
        font-weight: 600;
        color: #4B77BE;
    }

    .checkout--page__cart .checkout--page__cart__total .total--sum {
        margin-left: 2%;
    }

    .checkout--page__cart .checkout--page__clear__cart__btn {
        display: -ms-flexbox;
        display: flex;
    }

    .checkout--page__cart .checkout--page__clear__cart__btn .btn {
        padding: 8px;
        color: #fff;
        font-size: 14px;
        border-radius: 2px;
        font-weight: 400;
        background: linear-gradient(to bottom, #F74F4B, #E43137);
    }

    .checkout--page__cart .clear--cart__confirm__block .modal-content {
        border-radius: 0px;
    }

    .checkout--page__cart .clear--cart__confirm__block .modal-content .modal-body, .checkout--page__cart .clear--cart__confirm__block .modal-content .modal-footer, .checkout--page__cart .clear--cart__confirm__block .modal-content .modal-header {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .checkout--page__cart .clear--cart__confirm__block .modal-content .modal-footer button:first-child {
        border: 1px solid #F62459;
    }

    .checkout--page__cart .clear--cart__confirm__block .modal-content .modal-footer button:last-child {
        background: linear-gradient(to bottom, #1F3A93, #3A539B);
    }

    @media screen and (max-width: 1199px) {

        .sub-product {
        }
    }

    @media screen and (max-width: 991px) {
        .cart-product__name {
            width: 69%;
        }

        .cart-price {
            width: 40%;
        }

        /*.coupon .coupon--remove{
        width:28%;}
        .coupon .coupon--add{
        width: 28%;}*/
        .cart-item--inner {
            min-height: 75px;
        }
    }

    @media screen and (max-width: 767px) {
        /*.cart-item--quantity{
        font-size:16px;
        }*/
        input, select, textarea {
            font-size: 16px;
        }
    }

    @media screen and (max-width: 570px) {
        .cart-footer {
            align-items: stretch;
        }

        .coupon {
            width: 300px;
            margin-bottom: 20px;
            flex-direction: column;
        }
    }

    @media screen and (max-width: 380px) {
        .coupon {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// SummaryView.vue?40502dc8